var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "about-small-animation" }, [
    _c(
      "div",
      { staticClass: "about-small-animation__inner" },
      _vm._l(_vm.images, function(img, i) {
        return _c("img", {
          key: i,
          ref: "img",
          refInFor: true,
          class: "about-small-animation__img" + i,
          attrs: { src: "/img/" + img + ".png", alt: "" }
        })
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c77a70e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c77a70e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/AboutPageSmallAnimation.vue
// module id = 53sj
// module chunks = 2